"use strict";

/**
 * Events der Kartenaktionen.
 *
 * @enum {string}
 */
gc.gis.map.GCMapDrawInteractionEvent = {
    /**
     * Wird ausgelöst, wenn mit dem Zeichnen einer Geometrie begonnen wird.
     * @event gc.gis.map.GCMapDrawInteractionEvent#draw:start
     */
    DRAWSTART:  'draw:start',
    /**
     * Wird ausgelöst, wenn das Zeichnen Geometrie beendet wurde.
     * @event gc.gis.map.GCMapDrawInteractionEvent#draw:end
     */
    DRAWEND:    'draw:end'
};


/**
 * @classdesc
 * Interface für Kartenaktionen.
 *
 * @abstract
 * @class
 * @extends gc.gis.GCWrappable
 * @memberof gc.gis.map
 * @author Christian Schmidt <c.schmidt@brain-scc.de>
 *
 * @param {gc.gis.map.GCMapView} map Karte, der die Interaktion gehört
 * @param {Object} [opt_options] optionale Aufrufoptionen
 * @param {gc.gis.style.GCAbstractStyle[]} [opt_options.drawingStyle] Darstellungseigenschaften während des Zeichnens
 * @param {gc.gis.style.GCAbstractStyle[]} [opt_options.finalStyle] Darstellungseigenschaften für fertige Objekte
 * @param {boolean} [opt_options.allowClearDrawingArea] Flag welches anzeigt, ob die Inhalte des korrespondierenden
 *      Tracking-Layers durch die Funktion "Zeichenfläche leeren", verändert werden dürfen
 * @param {boolean} [opt_options.freehand=false] Freihandzeichnen aktivieren
 */
gc.gis.map.GCMapDrawInteraction = function(map, opt_options)
{
    gc.gis.GCWrappable.call(this);

    gc.gis.assert.isInstance(map, gc.gis.map.GCMapView);

    /** @type gc.gis.map.GCMapView */
    this.map = map;
};
gc.gis.map.GCMapDrawInteraction.prototype = Object.create(gc.gis.GCWrappable.prototype);


/**
 * Liefert den zugrundeliegenden Layer.
 * @return {gc.gis.layer.GCTrackingLayer}
 */
gc.gis.map.GCMapDrawInteraction.prototype.getLayer = gc.gis.abstractMethod;


/**
 * Setzt den Geometrietyp für der Zeichnen-Interaktion.
 *
 * @public
 * @abstract
 * @method
 *
 * @param {gc.gis.geom.GCGeometryType} geometryType Geometrietype der Zeichnen-Interaktion
 */
gc.gis.map.GCMapDrawInteraction.prototype.setGeometryType = gc.gis.abstractMethod;


/**
 * Liefert den Geometrietyp für der Zeichnen-Interaktion.
 *
 * @public
 * @abstract
 * @method
 */
gc.gis.map.GCMapDrawInteraction.prototype.getGeometryType = gc.gis.abstractMethod;


/**
 * Aktiviert oder deaktiviert das Freihandzeichnen.
 *
 * @public
 * @abstract
 * @method
 *
 * @param {boolean} enable
 */
gc.gis.map.GCMapDrawInteraction.prototype.enableFreehand = gc.gis.abstractMethod;


/**
 * Setzt die Karteninteraktion aktiv oder deaktiv.
 *
 * @public
 * @abstract
 * @method
 *
 * @param {boolean} state Status Kartenaktion aktiv/deaktiv
 */
gc.gis.map.GCMapDrawInteraction.prototype.setActive = gc.gis.abstractMethod;


/**
 * Zeigt an, ob die Karteninteraktion aktiv ist.
 *
 * @public
 * @abstract
 * @method
 */
gc.gis.map.GCMapDrawInteraction.prototype.isActive = gc.gis.abstractMethod;


/**
 * Setzt die Zeichenfläche zurück.
 *
 * @public
 * @abstract
 * @method
 */
gc.gis.map.GCMapDrawInteraction.prototype.clear = gc.gis.abstractMethod;